module.exports = __webpack_public_path__ + "img/icon_map_32_on_111.78ec46a9.png";